import * as A from '../actions/authActions';

const initialState = {
  authInfo: {
    isAuthorized: true,
    role: null,
    userId: null,
    userSignedUp: false,
    emailSent: false,
    confirmedEmail: null,
    tokensHasExpired: false,
    resetPasswordToken: null,
    passwordChangeConfirmed: false,
    contactUsSended: false,
    isAPIInProgress: false,
  },
  user: {},
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case A.signUp.success:
      return {
        ...state,
        authInfo: {
          ...state.user,
          userId: action.payload.id,
          userSignedUp: true,
        },
      };
    case A.signIn.success:
      return {
        ...state,
        authInfo: {
          ...state.user,
          userId: action.payload.id,
          userSignedUp: true,
          isAuthorized: true,
        },
      };

    case A.sendResetPasswordLink.success:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          emailSent: true,
        },
      };

    case A.confirmEmail.success:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          userId: action.payload.userId,
          confirmedEmail: action.payload.userEmail,
          lastEmail: action.payload.userEmail,
          resetPasswordToken: action.payload.resetPasswordToken,
        },
      };

    case A.removeUserData.type:
      return {
        ...initialState,
        ...(!action.payload?.reset && {
          authInfo: {
            ...initialState.authInfo,
            isAuthorized: false,
            ...(action.payload?.tokensHasExpired && {
              tokensHasExpired: true,
            }),
          },
        }),
      };

    case A.changeAuthInfo.type:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          ...action.payload,
        },
      };

    case A.setResetPasswordToken.type:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          resetPasswordToken: action.payload,
        },
      };

    case A.changePassword.success:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          passwordChangeConfirmed: true,
          lastEmail: action.payload.userEmail,
        },
      };

    case A.setUserData.type:
      return {
        ...state,
        user: { ...action.payload },
        authInfo: {
          ...state.authInfo,
          isAuthorized: true,
          lastEmail: action.payload.email,
        },
      };

    case A.setIsAuthorized.type:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          isAuthorized: action.payload,
        },
      };
    case A.setAPIInProgress.type:
      return {
        ...state,
        authInfo: {
          ...state.authInfo,
          isAPIInProgress: action.payload,
        },
      };
    default:
      return state;
  }
};
